import client from "./client";

const settlementAPI = {
  getAll: async () => {
    const res = await client.get("/settlement");
    return res.data;
  },

  getByProductAndState: async (productId, state) => {
    const res = await client.get(`/settlement/${productId}/${encodeURIComponent(state)}`);
    return res.data;
  },

  create: async (payload) => {
    const res = await client.post("/settlement", payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await client.put(`/settlement/${id}`, payload);
    return res.data;
  },

  delete: async (id) => {
    const res = await client.delete(`/settlement/${id}`);
    return res.data;
  },
};

export default settlementAPI;
